// Tabela Emoções e Órgãos — As 7 Emoções da MTC. Fiel ao material e à base expandida.

export const EMOTIONS = [
  {
    id: "alegria",
    emocao: "Alegria / prazer / euforia",
    aliases: [
      "alegria",
      "felicidade",
      "prazer",
      "euforia",
      "excitação",
    ],
    orgaoIds: [
      "coracao",
    ],
    orgaos: [
      "Coração",
    ],
    elemento: "Fogo",
    funcaoPositiva: "Alegria equilibrada traz conexão, entusiasmo e clareza mental.",
    excessoBloqueio: "Agitação, euforia excessiva, fala acelerada, insônia, inquietação, falta de foco.",
    sinaisFisicos: "Insônia, boca seca, sudorese, palpitações, ansiedade, tontura.",
    sourcePages: [10],
  },
  {
    id: "raiva",
    emocao: "Raiva",
    aliases: [
      "raiva",
      "ira",
      "fúria",
      "irritação",
      "irritabilidade",
      "frustração",
      "ressentimento",
    ],
    orgaoIds: [
      "figado",
      "vesicula-biliar",
    ],
    orgaos: [
      "Fígado",
      "Vesícula Biliar",
    ],
    elemento: "Madeira",
    funcaoPositiva: "Raiva equilibrada traz coragem, iniciativa e capacidade de tomar decisões.",
    excessoBloqueio: "Irritabilidade, explosões, frustração, tensão, impaciência, rigidez.",
    sinaisFisicos: "Dores de cabeça, tensão muscular, azia, olhos vermelhos, ciclos menstruais irregulares.",
    sourcePages: [10],
  },
  {
    id: "preocupacao",
    emocao: "Preocupação / ansiedade",
    aliases: [
      "preocupação",
      "ansiedade",
      "apreensão",
      "inquietação",
    ],
    orgaoIds: [
      "pulmao",
      "coracao",
      "baco-pancreas",
    ],
    orgaos: [
      "Pulmão",
      "Coração",
      "Baço-Pâncreas",
    ],
    elemento: null,
    funcaoPositiva: "Cuidado equilibrado traz zelo, atenção ao presente e senso de proteção.",
    excessoBloqueio: "Preocupação constante, ansiedade, apreensão, inquietação mental, dificuldade de relaxar.",
    sinaisFisicos: "Falta de ar, palpitações, digestão lenta, aperto no peito, fadiga.",
    sourcePages: [10],
  },
  {
    id: "pensamento-excessivo",
    emocao: "Pensamento / reflexão excessiva",
    aliases: [
      "pensar demais",
      "pensamento excessivo",
      "ruminação",
      "excesso de reflexão",
      "obsessão mental",
    ],
    orgaoIds: [
      "baco-pancreas",
      "coracao",
    ],
    orgaos: [
      "Baço-Pâncreas",
      "Coração",
    ],
    elemento: "Terra",
    funcaoPositiva: "Pensar com equilíbrio traz planejamento, discernimento e estabilidade.",
    excessoBloqueio: "Pensar demais, ruminação mental, pensamentos repetitivos, cansaço mental.",
    sinaisFisicos: "Digestão lenta, inchaço, perda de apetite, fadiga, peso na cabeça.",
    sourcePages: [10],
  },
  {
    id: "tristeza",
    emocao: "Tristeza / pesar",
    aliases: [
      "tristeza",
      "pesar",
      "luto",
      "melancolia",
      "vontade de chorar",
    ],
    orgaoIds: [
      "pulmao",
      "coracao",
    ],
    orgaos: [
      "Pulmão",
      "Coração",
    ],
    elemento: "Metal",
    funcaoPositiva: "Tristeza equilibrada traz sensibilidade, empatia e conexão profunda.",
    excessoBloqueio: "Tristeza profunda, luto prolongado, melancolia, sensação de perda, isolamento.",
    sinaisFisicos: "Tosse seca, falta de ar, pele ressecada, constipação, sensação de peso no peito.",
    sourcePages: [10],
  },
  {
    id: "medo",
    emocao: "Medo",
    aliases: [
      "medo",
      "temor",
      "insegurança",
      "pavor",
    ],
    orgaoIds: [
      "rins",
      "coracao",
      "figado",
      "vesicula-biliar",
    ],
    orgaos: [
      "Rins",
      "Coração",
      "Fígado",
      "Vesícula Biliar",
    ],
    elemento: "Água",
    funcaoPositiva: "Medo equilibrado traz prudência, sobrevivência e força interior.",
    excessoBloqueio: "Medo excessivo, temor, insegurança, pavor, sensação constante de ameaça.",
    sinaisFisicos: "Lombalgia, fraqueza nos joelhos, cansaço profundo, retenção de líquidos, zumbido.",
    sourcePages: [10],
  },
  {
    id: "susto",
    emocao: "Susto / choque / surpresa",
    aliases: [
      "susto",
      "choque",
      "sobressalto",
      "surpresa",
      "assusta fácil",
    ],
    orgaoIds: [
      "coracao",
      "rins",
      "vesicula-biliar",
    ],
    orgaos: [
      "Coração",
      "Rins",
      "Vesícula Biliar",
    ],
    elemento: null,
    funcaoPositiva: "Capacidade de reação espontânea, alerta saudável e adaptação ao inesperado.",
    excessoBloqueio: "Sobressalto fácil, estado de choque, perturbação do Shen, medo súbito.",
    sinaisFisicos: "Palpitações súbitas, tontura, tremores, acordar com susto, perda de fôlego.",
    sourcePages: [10],
  },
];

export const COMO_TRANSFORMAR = [
  "Respire profundo todos os dias.",
  "Movimente seu corpo diariamente.",
  "Expresse o que sente de forma saudável.",
  "Alimente-se com consciência e moderação.",
  "Durma bem e mantenha uma rotina tranquila.",
];

// Página física 11 / impressa 9: Emoções e Órgãos (Prancha introdutória e conceitual)
export const EMOCOES_PAGINA_11 = {
  titulo: "Emoções e Órgãos",
  subtitulo: "O que você sente, seu corpo reflete.",
  intro:
    "Na Medicina Tradicional Chinesa (MTC), cada emoção está relacionada a um ou mais órgãos. Quando uma emoção fica em excesso ou por muito tempo, ela pode desequilibrar a energia do órgão correspondente.",
  citacao: {
    linha1: "Equilíbrio emocional gera fluxo de energia.",
    linha2: "Fluxo de energia gera saúde.",
  },
  comoFunciona: {
    titulo: "Como funciona essa conexão?",
    texto1:
      "As emoções fazem parte da vida. Sentir é natural e necessário. O importante é não deixar que elas fiquem em excesso ou presas dentro de nós.",
    texto2:
      "Quando uma emoção fica desequilibrada, ela pode bloquear o fluxo de Qi, afetando o órgão relacionado e gerando sinais no corpo.",
  },
  lembreSe: {
    titulo: "Lembre-se",
    pontos: [
      "Sentir não é o problema.",
      "Reprimir, exagerar ou prolongar demais, sim.",
      "Observe, acolha e transforme.",
      "Equilíbrio emocional é autocuidado.",
    ],
  },
  linguagemDoCorpo: {
    titulo: "A linguagem do corpo",
    texto1: "Seu corpo sempre tenta te mostrar algo.",
    texto2: "Aprender a escutar é o primeiro passo para transformar.",
  },
  fechamento: {
    destaque: "A MTC não vê as emoções como inimigas, mas como mensageiras.",
    subtexto: "Quando compreendemos a mensagem, recuperamos o equilíbrio.",
    importante: "este guia é educativo e não substitui acompanhamento com profissionais de saúde.",
  },
  source: { pdfPage: 11, printedPage: "9" },
};
